import type { TUserModalConfig } from '../models/userModalModel'

export const USER_MODAL_CONFIG: TUserModalConfig = {  
  links: {
    about: {
      title: 'О нас', 
      items: [
        {
          title: 'О компании',
          to: '/about',
        },
        {
          title: 'Вакансии',
          to: '/about/careers',
        },
        {
          title: 'Контакты и реквизиты',
          to: '#contacts',
        },
      ]
    },
    partners: {
      title: 'Партнёрам',
      items: [
        {
          title: 'Стать партнёром',
          to: 'https://business.kazanexpress.ru/',
          target: '_blank',
        },
        {
          title: 'Магнит Пост',
          to: 'https://post.magnit.ru/',
          target: '_blank',
        },
        {
          title: 'Логистическим партнёрам',
          to: 'https://legal.mm.ru/logistics',
          target: '_blank',
        },
        {
          title: 'Сервис для корпоративных покупателей',
          to: 'https://b2b.kazanexpress.ru/',
          target: '_blank',
        },
        {
          title: 'Логистика',
          to: 'https://logistics.kazanexpress.ru/',
          target: '_blank',
        },
      ]
    },
  }
}